import useAuth from "src/hooks/useAuth";
import useHasAdditionalCharges from "./useHasAdditionalCharges";

export default function useReceivingWizardFlow(project) {
  const { user } = useAuth();
  const hasAdditionalCharges = useHasAdditionalCharges(project);
  const hasInboundReservations =
    !!user.company?.settings?.reservations && !!project?.settings?.add_inbounds_to_reservations;

  const totalSteps = 3 + Number(hasAdditionalCharges) + Number(hasInboundReservations);
  const itemsNextStep = hasAdditionalCharges
    ? "additional-charges"
    : hasInboundReservations
      ? "reservations"
      : "os&d";
  const additionalChargesNextStep = hasInboundReservations ? "reservations" : "os&d";
  const reservationsStepIndex = hasAdditionalCharges ? 3 : 2;
  const osdStepIndex = hasAdditionalCharges
    ? hasInboundReservations
      ? 4
      : 3
    : hasInboundReservations
      ? 3
      : 2;
  const osdBackStep = hasInboundReservations
    ? "reservations"
    : hasAdditionalCharges
      ? "additional-charges"
      : "items";

  return {
    hasAdditionalCharges,
    hasInboundReservations,
    totalSteps,
    itemsNextStep,
    additionalChargesNextStep,
    reservationsStepIndex,
    osdStepIndex,
    osdBackStep,
  };
}
